export function loadIntercom(appId = window.appConfig?.VUE_APP_INTERCOM_ID) {
    if (!appId) return null

    const existingIntercom = window.Intercom
    if (typeof existingIntercom === 'function') {
        return existingIntercom
    }

    const intercom = function () {
        intercom.c(arguments)
    }
    intercom.q = []
    intercom.c = function (args) {
        intercom.q.push(args)
    }
    window.Intercom = intercom

    const existingScript = document.querySelector(`script[src="https://widget.intercom.io/widget/${appId}"]`)
    if (existingScript) return intercom

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.async = true
    script.src = `https://widget.intercom.io/widget/${appId}`
    script.onerror = function () {
        console.error('Failed to load Intercom widget')
        window.Intercom.failedToLoad = true
    }

    const firstScript = document.getElementsByTagName('script')[0]
    firstScript.parentNode.insertBefore(script, firstScript)

    return intercom
}
